import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://runamatic.io';
const DEFAULT_TITLE = 'Runamatic - Automatización Inteligente de Atención al Cliente';
const DEFAULT_DESCRIPTION = 'Runamatic automatiza la atención al cliente en WhatsApp, Instagram, Facebook y más con IA. CRM omnicanal, chatbots inteligentes y coexistencia WhatsApp Business para empresas en Latinoamérica.';
const DEFAULT_KEYWORDS = 'automatización atención al cliente, chatbot WhatsApp Business, automatizar WhatsApp empresa, CRM omnicanal, chatbot IA para empresas, coexistencia WhatsApp, Meta Business Partner, automatización ventas';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  robots = 'index, follow',
  schema
}) => {
  const finalTitle       = title ? `${title} | Runamatic` : DEFAULT_TITLE;
  const finalDescription = description || DEFAULT_DESCRIPTION;
  const finalKeywords    = keywords    || DEFAULT_KEYWORDS;
  const finalCanonical   = canonical ? `${SITE_URL}${canonical}` : SITE_URL;
  const finalOgTitle     = ogTitle       || finalTitle;
  const finalOgDesc      = ogDescription || finalDescription;
  // Ensure OG image is always an absolute URL
  const finalOgImage     = ogImage
    ? (ogImage.startsWith('http') ? ogImage : `${SITE_URL}${ogImage}`)
    : DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <meta name="author" content="Runamatic" />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={finalCanonical} />

      {/* Open Graph */}
      <meta property="og:site_name" content="Runamatic" />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDesc} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={finalOgTitle} />
      <meta property="og:locale" content="es_LA" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@runamatic" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDesc} />
      <meta name="twitter:image" content={finalOgImage} />
      <meta name="twitter:image:alt" content={finalOgTitle} />

      {/* Hreflang */}
      <link rel="alternate" hreflang="es" href={finalCanonical} />
      <link rel="alternate" hreflang="x-default" href={finalCanonical} />

      {/* JSON-LD structured data */}
      {schema && (
        Array.isArray(schema)
          ? schema.map((item, i) => (
              <script key={i} type="application/ld+json">
                {JSON.stringify(item)}
              </script>
            ))
          : (
              <script type="application/ld+json">
                {JSON.stringify(schema)}
              </script>
            )
      )}
    </Helmet>
  );
};

export default SEO; 